import { render } from "./UECommunicationsListView.vue?vue&type=template&id=0e59cd90&scoped=true"
import script from "./UECommunicationsListView.vue?vue&type=script&lang=js"
export * from "./UECommunicationsListView.vue?vue&type=script&lang=js"

import "./UECommunicationsListView.vue?vue&type=style&index=0&id=0e59cd90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e59cd90"]])

export default __exports__